import React from "react";
import * as frm from "#glib/ui/component/model";
import { IApplicationContext } from "../context";
import { TermsOfServiceDialog } from "#glib/ui/component/user/TermsOfServiceDialog";
import { UserLanguages } from "#glib/ui/component/user/UserLanguages";
import { observer } from "mobx-react-lite";
import { FormGroup } from "@blueprintjs/core";

/**
 * SignupForm
 */
export const SignupForm: React.FunctionComponent<IApplicationContext> = (props) => {
	const { data } = props.store.data;

	const showTos = (ev: React.MouseEvent) => {
		ev.preventDefault();
		props.store.ui.toggle("showToS");
	};

	// --

	return (
		<form className='signup-form uk-form-stacked'>
			<TermsOfServiceModal {...props} />

			<div className='uk-margin-small'>
				<h4 className='uk-heading-bullet'>Organization</h4>

				<frm.TextAttrEditorGroupWithError
					store={props.store.data}
					name='orgName'
					formGroupProps={{
						label: "Organization name:",
						labelInfo: "(2 to 40 chars long)",
						className: "uk-width-1-1",
					}}
					inputGroupProps={{
						required: true,
					}}
				/>
			</div>

			<div className='uk-margin-small'>
				<h4 className='uk-heading-bullet'>Account</h4>

				<frm.TextAttrEditorGroupWithError
					store={props.store.data}
					name='email'
					formGroupProps={{
						label: "Email:",
						className: "uk-width-4-5",
					}}
					inputGroupProps={{
						readOnly: true,
					}}
				/>

				<div className='uk-grid uk-grid-small'>
					<frm.TextAttrEditorGroupWithError
						store={props.store.data}
						name='firstName'
						formGroupProps={{
							label: "First name:",
							className: "uk-width-1-2",
						}}
						inputGroupProps={{
							required: true,
						}}
					/>

					<frm.TextAttrEditorGroupWithError
						store={props.store.data}
						name='lastName'
						formGroupProps={{
							label: "Last name:",
							className: "uk-width-1-2",
						}}
						inputGroupProps={{
							required: true,
						}}
					/>
				</div>

				<div className='uk-margin-small'>
					<FormGroup label='Preferred languages:'>
						<UserLanguages store={props.store.data.languages} />
					</FormGroup>
				</div>

				<div className='uk-margin-small uk-text-center'>
					<frm.CheckboxAttrEditor
						store={props.store.data}
						name='ackTos'
						checkboxProps={{
							labelElement: (
								<span>
									I have read and accept the <a onClick={showTos}>terms of service</a>
								</span>
							),
						}}
					/>
				</div>
			</div>
		</form>
	);
};

// TermsOfServiceModal
const TermsOfServiceModal: React.FunctionComponent<IApplicationContext> = observer((props) => {
	const onClose = () => props.store.ui.mset({ showToS: false });

	// --

	return <TermsOfServiceDialog isOpen={props.store.ui.data.showToS} onClose={onClose} />;
});
